module.exports = __webpack_public_path__ + "img/footer_icon_instagram.1b301d33.svg";